<template>
  <b-modal
    id="edit-flat-modal"
    title="Flat Edit Modal"
    centered
    hide-footer
    size="lg"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    @show="onModalShow"
  >
    <template #modal-title>
      <h2 class="m-0">Flat Edit</h2>
    </template>
    <b-form @submit.prevent enctype="multipart/form-data">
      <b-form-group label-for="flat_no">
        <template #label>
          Flat No <span class="text-danger">*</span>
        </template>
        <b-input
          id="flat_no"
          v-model="flat_no"
          placeholder="Flat No"
          v-restrict="regex"
          required
        ></b-input>
      </b-form-group>

      <b-form-group label-for="building">
        <template #label>
          Building <span class="text-danger">*</span>
        </template>
        <v-select
          label="name"
          v-model="building"
          placeholder="Select Building"
          :options="buildings"
          autoscroll
          :clearable="true"
          @input="fetchFloors"
          required
        ></v-select>
      </b-form-group>

      <b-form-group label-for="floor">
        <template #label>
          Floor <span class="text-danger">*</span>
        </template>
        <v-select
          label="floor_no"
          v-model="floor"
          placeholder="Select Floor"
          :options="filteredFloors"
          autoscroll
          :clearable="true"
          :disabled="!building"
          required
        ></v-select>
      </b-form-group>


      <!-- <b-form-group label-for="owner">
        <template #label>
          Owner
        </template>
        <v-select
          label="label"
          v-model="owner"
          placeholder="Select Owner"
          :options="users"
          autoscroll
          :clearable="true"
          required
        ></v-select>
      </b-form-group> -->

      <b-form-group class="mt-2 text-right">
        <b-button
          type="submit"
          variant="primary"
          pill
          class="mr-1"
          @click="submit"
        >
          Update Flat
        </b-button>
        <b-button
          type="reset"
          variant="outline-secondary"
          @click="reset"
          pill
        >
          Reset
        </b-button>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { required } from "@validations";
import util from "@/util.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  mixins: [util],
  props: { flat: Object },
  data() {
    return {
      required,
      flat_no: "",
      regex: /^[a-zA-Z ]*$/,
      buildings: [],
      building: "",
      floors: [],
      floor: "",
      users: [],
      // owner: "",
    };
  },
  methods: {
    ...mapActions({
      updateFlat: "appData/updateFlat",
      getFloorsDDL: "appData/getFloorsDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
      // getUsersDDL: "appData/getUsersDDL",
    }),

    async submit() {
      try {
        const formData = new FormData();
        formData.append("flat_no", this.flat_no);
        formData.append("building", this.building.id);
        formData.append("floor", this.floor.id);
        // if (this.owner)
        // {
        //   formData.append("owner", this.owner.id);
        // }
        formData.append("updated_by", this.getLoggedInUser.id);
        const res = await this.updateFlat({
          payload: formData,
          pk: this.flat.id,
        });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Flat Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.reset();
          this.$nextTick(() => {
            this.$bvModal.hide("edit-flat-modal");
          });
        }
      } catch (error) {
        this.displayError(error);
      }
    },

    async onModalShow() {
      const buildings = await this.getBuildingsDDL();
      this.buildings = buildings.data;

      // const users = await this.getUsersDDL();
      // this.users = users.data.map(user => ({
      //   ...user,
      //   label: `${user.name} (Mobile: ${user.mobile_number})`,
      //   name: user.name,
      //   id: user.id,
      // }));

      if (this.flat) {
        this.flat_no = this.flat.flat_no;
        this.building = this.buildings.find(b => b.id === this.flat.building);
        await this.fetchFloors();
        this.floor = this.floors.find(f => f.id === this.flat.floor);
        this.owner = this.users.find(u => u.id === this.flat.owner);
      }
    },

    async fetchFloors() {
      if (!this.building) {
        this.floors = [];
        return;
      }
      const floors = await this.getFloorsDDL();
      this.floors = floors.data;
      this.floors = this.floors.filter(floor => floor.building === this.building.id);  
      this.floor = "";
    },

    reset() {
      this.flat_no = "";
      this.building = "";
      this.floors = [];
      this.floor = "";
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
    filteredFloors() {
      return this.floors;
    },    
  },
};
</script>

<style></style>
